// src/components/Gallery/CategoryNavigation.js
import React from 'react';

const CategoryNavigation = ({ selectedCategory, onCategoryChange }) => {
  const categories = [
    { key: 'paintings', label: 'Paintings' },
    { key: 'sculpture', label: 'Sculpture' },
    { key: 'wearable', label: 'Functional' }
  ];

  return (
    <div className="portfolio-category-nav">
      <div className="portfolio-category-nav-inner">
        {categories.map(category => (
          <button 
            key={category.key}
            className={`portfolio-category-button ${selectedCategory === category.key ? 'active' : ''}`}
            onClick={() => onCategoryChange(category.key)}
          >
            {category.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryNavigation;